module.exports = [{"id":1,"title":"л"},{"id":0,"title":"куб. см"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/capacityUnits.json
// module id = 494
// module chunks = 49